import type { MetaFunction } from 'react-router'
import ProductsPage from '~/pages/ProductsPage.jsx'

export const meta: MetaFunction = () => [
  { title: 'Products | S.J.S. Technology' },
  {
    name: 'description',
    content:
      'Browse VICTORY digital printing machines — solvent, eco-solvent, UV printers, CNC routers, CO2 lasers, laminators, and VisionJet inks & consumables.',
  },
  { property: 'og:title', content: 'Products | S.J.S. Technology' },
  { property: 'og:url', content: 'https://sjstechnology.in/products' },
]

export default function Products() {
  return <ProductsPage />
}
